import "./Nav.scss";
import { Link, useLocation } from "react-router-dom";
import LINKS from "./NavData";

const Nav = () => {
  const location = useLocation();
  const isHome = location.pathname === "/";

  return (
    <nav className="nav">
      <ul className="nav__list">
        {LINKS.map((l) => (
          <li key={l.href} className="nav__item">
            <Link
              to={isHome ? l.href.replace("/", "") : l.href}
              className="nav__link"
            >
              {l.label}
            </Link>
          </li>
        ))}
      </ul>
    </nav>
  );
};

export default Nav;
